<template>
  <OfferFeedbackDialog
    title="Algo inesperado aconteceu!"
    v-bind="$attrs"
    type="warning"
    @close="onClose"
  >
    <template #content>
      A {{ cptdPartnerName }} encontrou um problema com os dados enviados. Mas
      não se preocupe, você pode continuar sua contratação com a nossa equipe de
      atendimento pelo WhatsApp.
      <Button style="margin-top: 16px" type="ghost" @click="whatsappHelpLink">
        Continuar pelo WhatsApp
      </Button>
    </template>
  </OfferFeedbackDialog>
</template>
<script>
import { PartnersName } from '@/helpers/partners/common'
import { generateWhatsAppLink } from '@/helpers/whatsapp'
import { UnexpectedPartnerOfferStepEnum } from '@/helpers/offer-types'
import Button from '@/aasgard/components/buttons/Button.vue'
import OfferFeedbackDialog from '@/components/commomComponents/feedback/OfferFeedbackDialog.vue'
export default {
  name: 'UnexpectedPartnerOfferErrorFeedbackDialog',
  components: {
    Button,
    OfferFeedbackDialog,
  },
  props: {
    partner: { type: String, required: true },
    offerId: { type: String, required: true },
    step: { type: String, required: true },
  },
  computed: {
    cptdPartnerName() {
      return PartnersName[this.partner.toUpperCase() ?? ''] ?? ''
    },
    cptdStepPhrase() {
      switch (this.step) {
        case UnexpectedPartnerOfferStepEnum.COLD_OFFER_SIMULATE:
        case UnexpectedPartnerOfferStepEnum.SIMULATE:
          return `Ao simular a`
        case UnexpectedPartnerOfferStepEnum.SELECT:
          return `Ao selecionar a`
        case UnexpectedPartnerOfferStepEnum.UPLOAD_DOCS:
          return `Ao realizar o upload dos documentos da`
        case UnexpectedPartnerOfferStepEnum.SIGN_CONTRACT:
          return `Ao assinar o contrato da`
        default:
          return `Ao selecionar a`
      }
    },
  },
  methods: {
    whatsappHelpLink() {
      const offerWord =
        this.step !== UnexpectedPartnerOfferStepEnum.SIMULATE
          ? 'oferta'
          : 'pré-oferta'
      window.open(
        generateWhatsAppLink({
          text: `${this.cptdStepPhrase} ${offerWord} abaixo, a parceira ${this.cptdPartnerName} encontrou um problema com os dados que enviei. Poderia me ajudar?\nIdentificação da ${offerWord}: ${this.offerId}`,
        }),
        '_self',
      )
    },
    onClose() {
      this.$router.push({
        path: '/ofertas',
      })
    },
  },
}
</script>
<style lang="scss"></style>
